(() => {
  if (customElements.get('cc-photo-gallery')) return;
  class ClientPhotoGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.items = Array.from(this.querySelectorAll('[data-photo-item]'));
      this.initialCount = Math.max(4, Number(this.dataset.initialCount) || 8);
      this.visibleCount = this.initialCount;
      this.category = 'all';
      this.dialog = this.querySelector('dialog');
      this.viewer = this.querySelector('[data-photo-viewer]');
      this.dialogCaption = this.dialog.querySelector('[data-photo-caption]');
      this.counter = this.querySelector('[data-photo-count]');
      this.moreButton = this.querySelector('[data-photo-more]');
      this.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const filter = target.closest('[data-photo-filter]');
        if (filter) {
          this.category = filter.dataset.photoFilter;
          this.visibleCount = this.initialCount;
          this.querySelectorAll('[data-photo-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
          this.update();
          return;
        }
        if (target.closest('[data-photo-more]')) {
          this.visibleCount += this.initialCount;
          this.update();
          return;
        }
        const opener = target.closest('[data-photo-open]');
        if (opener) {
          this.opener = opener;
          this.currentIndex = this.filteredItems.findIndex(item => item.contains(opener));
          this.showPhoto();
          if (!this.dialog.open) this.dialog.showModal();
          document.documentElement.classList.add('cc-photo-modal-open');
        }
        if (target.closest('[data-photo-close]')) this.dialog.close();
        if (target.closest('[data-photo-previous]')) this.navigate(-1);
        if (target.closest('[data-photo-next]')) this.navigate(1);
      });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.navigate(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('cc-photo-modal-open');
        if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
      });
      this.update();
    }
    update() {
      this.filteredItems = this.items.filter(item => this.category === 'all' || item.dataset.category === this.category);
      this.items.forEach(item => { item.hidden = true; });
      this.filteredItems.slice(0, this.visibleCount).forEach(item => { item.hidden = false; });
      if (this.moreButton) this.moreButton.hidden = this.visibleCount >= this.filteredItems.length;
      if (this.counter) this.counter.textContent = this.dataset.showingLabel.replace('[shown]', String(Math.min(this.visibleCount, this.filteredItems.length))).replace('[total]', String(this.filteredItems.length));
    }
    navigate(direction) {
      this.currentIndex = (this.currentIndex + direction + this.filteredItems.length) % this.filteredItems.length;
      this.showPhoto();
    }
    showPhoto() {
      const item = this.filteredItems[this.currentIndex];
      if (!item) return;
      const button = item.querySelector('[data-photo-open]');
      this.viewer.src = button.dataset.photoFull;
      this.viewer.alt = button.dataset.photoAlt || '';
      this.dialogCaption.textContent = button.dataset.photoCaption || '';
      this.querySelector('[data-photo-position]').textContent = this.dataset.photoLabel.replace('[current]', String(this.currentIndex + 1)).replace('[total]', String(this.filteredItems.length));
    }
  }
  customElements.define('cc-photo-gallery', ClientPhotoGallery);
})();
